/* eslint-env browser */
import * as ActionTypes from 'actions';

const initialState = [];

export default function(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
  case ActionTypes.ROUTER_DID_CHANGE:
    if (window.react_ga) {
      window.react_ga.pageview(payload.location.pathname);
    }
    if (payload.location) {
      const history = state.slice(0, 49);
      history.unshift(payload.location);
      return history;
    }
    return state;

  case ActionTypes.ROUTER_RECORD_BACK:
    // A bit hacky and probably not appropriate to be in a reducer but we need to rewind the routerHistory
    // when the user clicks a 'back' type button. This component that triggered the back type action
    // also triggering the ROUTER_RECORD_BACK action since this can't be automated
    if (state.length > 2 && state[0].action === 'REPLACE') {
      return state.slice(2, 50);
    }
    return state;

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/routerHistory.js